import type { ColorVariant, Theme, ThemeResponse } from "@/models/themes.model"

export function mapThemeResponseToTheme(theme: ThemeResponse): Theme {
  return {
    id: theme.id,
    name: theme.code,
    colors: theme.theme,
    hasGradient: true,
    backgroundImage: theme.code === "cis-2025" ? "/pattern.svg" : undefined,
  }
}

export function mapThemeToThemeResponse(theme: Theme): ThemeResponse {
  return {
    id: theme.id,
    code: theme.name,
    theme: theme.colors as ColorVariant,
    x_order: 0,
    is_active: true,
    descriptions: {},
  }
}
